import { reactive, computed } from '@vue/composition-api'
import store from '@/store'
import * as common from '@/util/common'
import * as apiQA from '@/api/qa'
import * as apiKnowledge from '@/api/knowledge'
import * as apiNote from '@/api/note'
import * as _ from 'lodash'
import moment from 'moment'

/**
 * サジェスト用リアクティブ変数を取得
 * @params {integer} searchCategory 対象（検索カテゴリ）
 * @params {object} group1 使用元の各値を参照渡しするための変数
 */
export const getCommonSuggest = (group1) => {

  const preState = reactive({
    search_text: ''
  })

  const suggest = reactive({

    _displayTip: false,
    displayTip: computed({
      get: () => {
        return suggest._displayTip && (suggest.fixedCount !== null)
      },
      set: (value) => {
        suggest._displayTip = value
        if (!value) {
          suggest.count = null
        }
      }
    }),

    search_text: computed(() => {
      return preState.search_text
    }),

    lists: [],
    count: null,

    fixedCount: computed(() => {
      return _.isNumber(suggest.count) ? common.breakComma(suggest.count) : null
    }),

    /**
     * キー入力時
     */
    keyInput: (e) => {
      if (preState.search_text === e.target.value) {
        preState.search_text = e.target.value
        return
      }
      preState.search_text = e.target.value
      suggest.getSuggest()
      suggest._displayTip = true
    },


    // 前回getSuggest()を実行した時に選択した検索カテゴリ
    prevSearchCategory: '',
    // 前回getSuggest()を実行した時に使用したキーワード
    prevSearchText: '',
    // 最後に検索したキーワード
    lastSearchText: '',
    // 前回getSuggest()を実行したタイムスタンプ(ミリ秒)
    prevGetSuggestTime: 0,
    // getSuggest()の実行間隔(ミリ秒)
    intervalTimeOfGetSuggest: 500, 

    /**
     *　サジェスト取得処理
     */
    getSuggest: () => {
      // 検索カテゴリ
      const searchCategory = store.state.search.searchCategory

      // 検索キーワード
      const searchText = suggest.search_text

      // 「表記ゆれ・同意語を含む」のチェック状態の値
      const isFuzzy = group1.is_fuzzy_input

      // 現在のタイムスタンプ(ミリ秒)
      const currentTime = (new Date()).getTime()

      if (suggest.prevSearchCategory === '' || searchCategory !== suggest.prevSearchCategory) {
        // 初回または検索カテゴリが変わった場合は初期化
        suggest.prevSearchText = ''
        suggest.prevGetSuggestTime = 0
      }

      if (suggest.prevGetSuggestTime !== 0) {
        // 一度でもgetSuggest()を実行した場合

        // 前回からの経過時間(ミリ秒)
        const diffTime = currentTime - suggest.prevGetSuggestTime

        if (diffTime < suggest.intervalTimeOfGetSuggest) {
          // intervalTimeOfGetSuggestミリ秒経過していない場合は以降の処理を実行しない
          return
        }
        if (searchCategory === suggest.prevSearchCategory && searchText === suggest.prevSearchText) {
          // 検索キーワードが変わっていない場合は以降の処理を実行しない
          return
        }
      }
      // 前回検索した、検索カテゴリキーワード、実行時間をメンバ変数に保持する
      suggest.prevSearchCategory = searchCategory
      suggest.prevSearchText = searchText
      suggest.prevGetSuggestTime = currentTime

      
      // 検索実行
      const preParams = {
        search_text: searchText,
        is_fuzzy: isFuzzy
      }

      const params = _.pickBy(preParams, (value, key) => {
        return (value !== null)
      })

      const requestLists = []

      // ※サジェストは表示しないことになった。
      // // サジェスト一覧APIをコール
      // const params = {}
      // if (searchCategory === 'qa') {
      //   params.target = 1 // 1=QA
      // } else if (searchCategory === 'book') {
      //   params.target = 2 // 2=書籍
      // } else if (searchCategory === 'download') {
      //   params.target = 5 // 5=書式DL
      // } else {
      //   return
      // }
      // params.search_text = searchText

      // requestLists.push(
      //   apiCommon.listSuggest(params)
      //     .then(r => {
      //       const data = r.data

      //       if (data.status === 0) {
      //         suggest.lists = data.list
      //       }
      //     })
      // )

      requestLists.push(
        // キーワード検索結果件数取得APIをコール
        suggest.countKeywordSearchResults(searchCategory, params)
      )
      
      Promise.all(requestLists)

      // 検索実行間隔（intervalTimeOfGetSuggestミリ秒）を設けている関係で、
      // タイミングによって最終確定のキーワードで検索されない可能性があるため、
      // 念のため、intervalTimeOfGetSuggestミリ秒後にgetSuggest()メソッドを再実行する
      //
      // ※リトライ回数分、時間をずらしてgetSuggest()メソッドを実行する
      // (getSuggest()メソッド内で、検索キーワードが変わっていない場合は以降の処理を実行しない対応をしているので問題無い)
      const retryCount = 5 // リトライ回数
      for (let count = 0; count < retryCount; count++) {
        setTimeout(() => {
          suggest.getSuggest()
        }, suggest.intervalTimeOfGetSuggest * count)
      }
    },

    // /**
    //  * サジェスト項目をクリックした時
    //  */
    // click: (searchCategory, searchText) => {

    //   preState.search_text = searchText

    //   const preParams = {
    //     search_text: suggest.search_text,
    //     is_fuzzy: suggest.is_fuzzy
    //   }

    //   const params = _.pickBy(preParams, (value, key) => {
    //     return (value !== null)
    //   })

    //   // キーワード検索結果件数取得APIをコール
    //   suggest.countKeywordSearchResults(searchCategory, params)

    //   suggest.lists = []
    // },

    /**
     * キーワード検索結果件数取得APIをコール
     */
    countKeywordSearchResults: (searchCategory, params) => {

      const searchText = params.search_text
      const isFuzzy = params.is_fuzzy

      // 最後に検索したキーワード
      suggest.lastSearchText = searchText

      if (
        searchCategory === 'qa' ||
        searchCategory === 'book' ||
        searchCategory === 'download'
      ) {
        // キーワード検索結果件数取得APIをコール

        let searchRange
        if (searchCategory === 'qa') {
          // QA一覧の場合
          searchRange = 3 // 3=QA
        } else if (searchCategory === 'book') {
          // 書籍一覧の場合
          searchRange = 1 // 1=書籍一覧画面
        } else if (searchCategory === 'download') {
          // 書式DL一覧の場合
          searchRange = 2 // 2=書式DL画面
        }

        const param2 = {
          search_text: searchText,
          is_fuzzy: isFuzzy,
          search_range: searchRange
        }

        apiQA
          .countKeywordSearchResults(param2)
          .then(r => {
            const data = r.data
            if (data.status === 0) {
              if (searchText === suggest.lastSearchText) {
                suggest.count = data.count
              }
            }
          })
      } else if (searchCategory === 'knowledge') {
        // 最新ナレッジキーワード検索結果数取得APIをコール

        const searchDateStart = store.state.knowledge.search.search_date_start
        const searchDateEnd = store.state.knowledge.search.search_date_end

        const param2 = {
          keyword: searchText,
          is_fuzzy: isFuzzy
        }
        if (moment(searchDateStart).isValid()) {
          param2.search_date_start = searchDateStart
        }
        if (moment(searchDateEnd).isValid()) {
          param2.search_date_end = searchDateEnd
        }

        apiKnowledge
          .searchCount(param2)
          .then(r => {
            const data = r.data
            if (data.status === 0) {
              if (searchText === suggest.lastSearchText) {
                suggest.count = data.count
              }
            }
          })
      } else if (searchCategory === 'note') {
        // ノート一覧件数取得APIをコール

        const param2 = {
          search_text: searchText
        }

        apiNote
          .count(param2)
          .then(r => {
            const data = r.data
            if (data.status === 0) {
              if (searchText === suggest.lastSearchText) {
                suggest.count = data.count
              }
            }
          })
      }
    },

    /**
     * リストを閉じる 
     */
    close: () => {
      suggest.lists = []
      suggest.count = null
    }
    
  })

  return suggest
}
